var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:{
        mobile: _vm.isMobile(),
        pc: !_vm.isMobile(),
        localTesting: _vm.localTesting,
    }},[_c('AppBar',{attrs:{"noShadow":_vm.isFlatRoute}}),_c('div',{class:_vm.mainClasses},[_c('LeftMenu',{attrs:{"flat":_vm.isFlatRoute}}),_c('router-view')],1),_c('Footer',{attrs:{"flat":_vm.isFlatRoute}}),_c('notifications',{staticClass:"noti-root",attrs:{"group":"noti","position":"bottom right","duration":5000},scopedSlots:_vm._u([{key:"body",fn:function(props){return [_c('PushNotiBox',{attrs:{"data":props.item.data},on:{"click":function($event){return props.close()}}})]}}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }